import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { orderBy as _orderBy } from 'lodash-es';

import { API_STATUS, SESSION_STATUS } from 'store/constants';
import { fetchSessions, addSession, updateSession, fetchSessionDetails, fetchSessionFeedbackQuestions } from './sessionsAPI';

const initialState = {
	status: API_STATUS.CLEAR,
	eventsList: [],
	filteredEventsList: []
};

export const getSessionsAsync = createAsyncThunk('sessions/fetchEvents', async () => {
	const eventsResponse = await fetchSessions();
	const mappedSessions = (eventsResponse || []).map(session => ({
		...session,
		scheduledAt: new Date(session.eventDateTime).getTime()
	}));
	const events = _orderBy(mappedSessions, 'scheduledAt');

	return { events };
});

export const getSessionDetailsAsync = createAsyncThunk('sessions/fetchSessionDetails', async eventId => {
	const event = await fetchSessionDetails(eventId);
	return { event };
});

export const addSessionAsync = createAsyncThunk('sessions/addSession', async newEvent => {
	const event = await addSession(newEvent);
	return { event };
});

export const updateSessionAsync = createAsyncThunk('sessions/updateSession', async payload => {
	const { eventId, event: updatedEvent } = payload;
	const event = await updateSession(eventId, updatedEvent);
	return { event };
});

export const fetchSessionFeedbackQuestionsAsync = createAsyncThunk('sessions/fetchSessionFeedbackQuestions', async () => {
	const feedbackQuestions = await fetchSessionFeedbackQuestions();
	return { feedbackQuestions };
});

const sessionsSlice = createSlice({
	name: 'events',
	initialState,
	reducers: {
		setEvents: (state, action) => {
			state.events = action.payload.events;
			state.loaded = true;
		}
	},

	extraReducers: builder => {
		builder
			.addCase(getSessionsAsync.fulfilled, (state, action) => {
				state.eventsList = action.payload.events;
				state.status = API_STATUS.COMPLETED;
				state.loaded = true;
			})
			.addCase(getSessionsAsync.rejected, state => {
				state.status = API_STATUS.REJECTED;
			})
			.addCase(addSessionAsync.fulfilled, (state, action) => {
				state.eventsList.push(action.payload.event);
				state.eventAdded = API_STATUS.COMPLETED;
			})
			.addCase(addSessionAsync.rejected, state => {
				state.eventAdded = API_STATUS.REJECTED;
			})
			.addCase(updateSessionAsync.fulfilled, (state, action) => {
				state.eventsList = state.eventsList.map(event => {
					if (event.id !== action.payload.event.id) {
						return event;
					}

					return Object.assign({}, event, {
						...action.payload.event
					});
				});

				// console.log(current(state));
			})
			.addCase(updateSessionAsync.rejected, state => {
				state.eventUpdated = API_STATUS.REJECTED;
			})
			.addCase(getSessionDetailsAsync.fulfilled, (state, action) => {
				if (state.eventsList.some(event => event.id !== action.payload.event.id)) {
					state.eventsList.push(action.payload.event);
				}
				state.fetchEvent = API_STATUS.COMPLETED;
			})
			.addCase(getSessionDetailsAsync.rejected, state => {
				state.fetchEvent = API_STATUS.REJECTED;
			})
			.addCase(fetchSessionFeedbackQuestionsAsync.fulfilled, (state, action) => {
				state.feedbackQuestions = action.payload.feedbackQuestions;
				state.feedbackQuestionsStatus = API_STATUS.COMPLETED;
			})
			.addCase(fetchSessionFeedbackQuestionsAsync.rejected, state => {
				state.feedbackQuestionsStatus = API_STATUS.REJECTED;
			});
	}
});

export const selectSessionsLoaded = state => state.events.loaded;
export const selectSessionsList = state => state.events.eventsList;
export const selectPublicSessionsList = state => {

	const resp = state.events.eventsList.filter(session => session.status !== SESSION_STATUS.DRAFT);
	console.log(resp);
	return resp;
};
export const selectSessionDetails = state => eventId => state.events.eventsList.find(e => e.id === eventId);
export const selectSessionFeedbackQuestions = state => state.events.feedbackQuestions?.questions;

export const { setEvents } = sessionsSlice.actions;

export default sessionsSlice.reducer;
